/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForAzureCsp extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForAzureCsp.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForAzureCsp>): CostProcessingPeriodMemoryForAzureCsp {
        let obj = Object.assign(new CostProcessingPeriodMemoryForAzureCsp(), model);
        CostProcessingPeriodMemoryForAzureCsp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForAzureCsp>): CostProcessingPeriodMemoryForAzureCsp {
        if (!model) return null;
        return CostProcessingPeriodMemoryForAzureCsp.newInstance(<CostProcessingPeriodMemoryForAzureCsp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForAzureCsp) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForAzureCsp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForAzureCsp): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForAzureCsp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.skipped_line_items === undefined) {
            this.skipped_line_items = 0;
        }
    }

    /**
     * Number of skipped line items
     */
    skipped_line_items: number;

    /**
     * Processing completed or not
     */
    invoice_processed: boolean;

    /**
     * Fully processed reports
     */
    processed_reports: Array<string>;

    /**
     * Missing reports
     */
    missing_reports: Array<string>;

}
